/*
 * @Author: Dong
 * @Date: 2022-05-05 16:14:17
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-06-08 14:58:24
 */
import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { Tabs } from 'sup-ui';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { reducerStates } from 'root/store/types';
import { getHostDetailApi } from 'root/services/disk';
import { getSuposInstanceApi } from 'root/services/packageManage';
import { checkEnv } from 'root/services/manager';

import messages from './messages';
import styles from './index.less';
import ServiceManage from './ServiceManage';
import SystemManage from './SystemManage';
import SystemApplication from './SystemApplication';
import HostMonitor from './HostMonitor';
import SyncBack from './SyncBack';
import SysNoSupOS from './SysNoSupOS';
import WarnNotification from 'root/pages/WarnNotification';
import { common } from 'root/store/actions';
import { envManage } from './store/actions';

const { TabPane } = Tabs;

const MonitorManage = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { acitveKey } = useSelector((state: reducerStates) => state.envManage);
  const [hostDisable, setHostDisable] = useState(true);
  const envStatus = sessionStorage.getItem('envStatus');
  const { isSuposInstalled = '', cluster = 0 } = envStatus ? JSON.parse(envStatus) : {};
  const runtimeEnvId = sessionStorage.getItem('runtimeEnvId');

  const sysBack = {
    type: 'syncBack',
    key: '5',
    title: messages.syncBack,
    module: <SyncBack />,
  };

  const tabData: any = isSuposInstalled
    ? [
        {
          type: 'systemManage',
          title: messages.systemManage,
          module: <SystemManage />,
          key: '1',
        },
        {
          type: 'hostMonitor',
          title: messages.hostMonitor,
          module: <HostMonitor />,
          key: '2',
        },
        {
          type: 'serviceManage',
          title: messages.serviceManage,
          module: <ServiceManage />,
          key: '3',
        },
        {
          type: 'systemApplication',
          title: messages.systemApplication,
          key: '4',
          module: <SystemApplication />,
        },
        {
          type: 'warnNotification',
          key: '6',
          title: messages.warnNotification,
          module: <WarnNotification />,
        },
      ]
    : [
        {
          type: 'systemManage',
          title: messages.systemManage,
          module: <SysNoSupOS />,
          key: '1',
        },
        {
          type: 'hostMonitor',
          title: messages.hostMonitor,
          module: <HostMonitor />,
          key: '2',
        },
      ];

  useEffect(() => {
    dispatch(
      envManage.changeEnvStatus({
        cluster,
        isSuposInstalled,
      }),
    );
    if (!runtimeEnvId) return;
    if (cluster) return;
    getList();
    getSuposInstanceApi();
  }, []);

  useEffect(() => {
    checkPackageUrl();
    if (!runtimeEnvId) return;
    instanceCheckEnv({ runtimeEnvId });
  }, []);

  // 检查安装包目录是否创建，如果未创建，主机监测不可点击
  const checkPackageUrl = () => {
    getSuposInstanceApi().then((res) => {
      setHostDisable(!res.data);
    });
  };
  // 集群环境没有备份还原
  if (!cluster && isSuposInstalled) tabData.push(sysBack);

  const handleChangeKey = (key: string) => {
    dispatch(
      envManage.changeEnvStatus({
        acitveKey: key,
      }),
    );
  };

  // 根据id对单个实例环境检测
  const instanceCheckEnv = (params: any) => {
    checkEnv(params).then((res) => {
      const { serverInfo, partitionInfo, status = [] } = res.data;
      const suposInfo = status.find((item: any) => item.name === 'supos');
      const suposStatus = suposInfo?.status;

      // 更新服务器状态
      dispatch(
        common.serverStatus({
          sereverInfo: serverInfo,
          partionInfo: partitionInfo,
          status,
        }),
      );

      // supos安装中和安装等待中
      if (suposStatus === 'INSTALLING' || (suposStatus === 'WAITING' && suposInfo?.installType === 1)) {
        return jumpTo({
          sysStatus: 'doing',
          route: '/supos',
        });
      }
      dispatch(common.sysStatus({ sysStatus: '' }));
    });
  };

  const jumpTo = ({ sysStatus, route }: { sysStatus: string; route: string }) => {
    // 更新系统状态 , 跳转到对应状态下的路由
    dispatch(common.sysStatus({ sysStatus: sysStatus }));
    navigate(route);
  };

  const getList = () => {
    getHostDetailApi({ ids: [] }).then((res: any) => {
      const {
        data: { serverNodeBriefs = [] },
      } = res;
      if (!cluster) {
        // 单机环境保存主机id
        dispatch(
          envManage.changeEnvStatus({
            singleNodeId: serverNodeBriefs[0]?.id, // 主机节点id
          }),
        );
        sessionStorage.setItem('singleNodeId', serverNodeBriefs[0]?.id ? serverNodeBriefs[0].id : '');
      }
    });
  };

  return (
    <div className={styles.container}>
      <Tabs activeKey={acitveKey} onChange={handleChangeKey} size="small" animated={false}>
        {tabData.map((i: any) => (
          <TabPane tab={intl.formatMessage(i.title)} key={i.key} disabled={i.key === '2' && hostDisable}>
            {i.module}
          </TabPane>
        ))}
      </Tabs>
    </div>
  );
};

export default MonitorManage;
